module.exports = __webpack_public_path__ + "static/media/gun-safes.30c7a842.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/gun-safes.png
// module id = 1297
// module chunks = 0